import * as React from 'react';
import {useDispatch} from 'react-redux';

import type {FilterObject} from 'nutshell-core/types';

import {DashboardCard} from 'shells/dashboard/card/dashboard-card';
import {getIllustration} from 'shells/onboarding-checklist/helpers';
import {PromoStateOverlay} from 'shells/promo-state-overlay/promo-state-overlay';

// @ts-expect-error
import {useGetChannelDashboard} from './graphql/hooks';
import * as actions from './report/facebook/facebook-actions';
import {FacebookChart} from './report/facebook/facebook-chart';

import styles from './dashboard.module.css';

const REPORT_PARAMS = {
    dateRangeType: 'period',
    facet: 'count',
    gap: 'd',
    segment: 'interactionType',
} as const;

type Props = {
    dateRange: string;
    activeFilters: FilterObject[];
    onParamChange: (arg1: any, arg2: boolean) => void;
    shouldShowPromo: boolean;
};

export function FacebookCard(props: Props) {
    const {activeFilters} = props;

    const {channelDashboard, isLoading} = useGetChannelDashboard({
        timespan: props.dateRange,
        channelType: 'facebook',
    });

    const dispatch = useDispatch();

    const stats = channelDashboard ? channelDashboard.stats : [];

    React.useEffect(() => {
        dispatch(
            actions.requestReportData({
                reportParams: REPORT_PARAMS,
                filters: activeFilters,
            })
        );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activeFilters]);

    return (
        <DashboardCard
            title='Facebook Messenger'
            subtitle='Communicate with customers who message your Facebook page'
            isLoading={isLoading}
            mainContent={{
                statsProps: {stats},
                content: (
                    <div className={styles.chart}>
                        <FacebookChart
                            activeFilters={props.activeFilters}
                            onParamChange={props.onParamChange}
                            reportParams={REPORT_PARAMS}
                            height={346}
                            containerHeight={346}
                        />
                    </div>
                ),
            }}
            promoStateOverlay={
                props.shouldShowPromo && (
                    <PromoStateOverlay
                        promoStateProps={{
                            isHorizontal: true,
                            imageComponent: getIllustration('setupFacebook'),
                            title: 'Integrate Facebook With Nutshell',
                            subtitle:
                                'Connect your Facebook page to Nutshell to start engaging with customers who message your page.',
                            primaryCta: null,
                            secondaryCta: {
                                text: 'Integrate Facebook',
                                url: '/inbox/settings/facebook',
                            },
                            blueImageBackground: true,
                        }}
                    />
                )
            }
        />
    );
}
